var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.offer.success ? _c('div', {
    ref: "mortgageResult",
    staticClass: "mortgage-result-broker"
  }, [_c('div', {
    staticClass: "mortgage-parameters"
  }, [_c('img', {
    staticClass: "bank-logo",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.offer.bank.logo,
      "loading": "lazy",
      "alt": _vm.offer.extra.bank_code_name
    }
  }), _c('div', {
    staticClass: "bold wrap100px suma amount-editor"
  }, [_vm.editingAmount ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.amountDraft,
      expression: "amountDraft"
    }],
    ref: "amountInput",
    staticClass: "amount-editor__input",
    attrs: {
      "type": "number",
      "min": "1",
      "step": "100"
    },
    domProps: {
      "value": _vm.amountDraft
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submitAmountEdit.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancelAmountEdit.apply(null, arguments);
      }],
      "blur": _vm.submitAmountEdit,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.amountDraft = $event.target.value;
      }
    }
  }) : _c('button', {
    staticClass: "amount-editor__button",
    attrs: {
      "type": "button",
      "title": "Prepísať výšku hypotéky pre túto banku"
    },
    on: {
      "click": _vm.startAmountEdit
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.offer.pozicana_suma)) + " EUR ")])]), _c('div', {
    staticClass: "bold wrap50px fixacia"
  }, [_vm._v(" " + _vm._s(_vm.offer.fix)), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("R")])]), !_vm.offer.loadingSadzba ? _c('div', {
    staticClass: "bold wrap50px sadzba"
  }, [_vm._v(" " + _vm._s(_vm._f("toFloor")(_vm.offer.sadzba, 2))), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]) : _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  })], 1), !_vm.offer.loadingSplatka ? _c('div', {
    staticClass: "bold wrap100px splatka",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.offer.mesacna_splatka)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _vm.offer.ucel === 'refinancovanie' ? _c('div', {
    staticClass: "usetrene"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.refinancovanieDifference)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]) : _vm._e()]) : _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "d-flex flex-row align-items-center splatnost"
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    "class": {
      'disabled-maturity': _vm.offer.splatnost_r === 0
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f29_icons8-expand-arrow.svg",
      "alt": ""
    },
    on: {
      "click": _vm.decreaseMaturity
    }
  }), _c('div', {
    staticClass: "bold wrap50px splatnost",
    on: {
      "click": _vm.openMaturityInputPopup
    }
  }, [_vm._v(" " + _vm._s(_vm.offer.splatnost_r) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("R")])]), _c('img', {
    staticClass: "nav-link-icon filter-primary",
    "class": {
      'disabled-maturity': _vm.offer.splatnost_r === _vm.maxMaturity
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": _vm.increaseMaturity
    }
  })])]), _c('div', {
    staticClass: "bold d-flex align-items-center poplatok",
    "class": {
      'note-present': _vm.bankNotes.length !== 0
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.offer.popl_sprac_hypo)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])])]), _vm.ltv90Notice ? _c('div', {
    staticClass: "ltv-90-notice",
    "class": {
      'ltv-90-notice--missing': _vm.ltv90Notice.missing_rate_change
    }
  }, [_c('strong', [_vm._v("90 % LTV prirážka")]), _c('span', [_vm._v(_vm._s(_vm.ltv90NoticeText))])]) : _vm._e(), _c('div', {
    staticClass: "discount-list"
  }, _vm._l(_vm.offer.extra.mozne_zmeny_sadzieb, function (discount, key) {
    return _c('discount-item', {
      key: key,
      attrs: {
        "discount": discount,
        "mortgage-rate-changes": _vm.mortgageRateChanges,
        "mortgage-id": _vm.mortgageId
      },
      on: {
        "discount-change": _vm.handleSadzbaChange
      }
    });
  }), 1), _c('div', {
    staticClass: "discount-list"
  }, _vm._l(_vm.$store.getters['formStore/getBankByKey'](_vm.offer.bank.code).notes, function (noteObject, index) {
    return _c('div', {
      key: index,
      staticClass: "discount-item kampane"
    }, [_vm._v(" " + _vm._s(noteObject.note) + " ")]);
  }), 0), _c('div', {
    staticClass: "offer-actions"
  }, [_c('button', {
    staticClass: "offer-action offer-action--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.createApplication();
      }
    }
  }, [!_vm.loading ? _c('span', [_vm._v(" Vybrať ")]) : _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall offer-action__loader",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('button', {
    staticClass: "offer-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.showCampaign(_vm.offer.bank.code);
      }
    }
  }, [_vm._v(" Kampane ")]), _c('button', {
    staticClass: "offer-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openHelperPopup(_vm.offer.bank.code);
      }
    }
  }, [_vm._v(" Metodika ")]), _c('client-dti-info-handler', {
    attrs: {
      "action-button": "",
      "bank-key": _vm.offer.extra.bank_code_name,
      "offer": _vm.offer,
      "rules": ['priority']
    }
  }), _c('button', {
    staticClass: "offer-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v(" Kopírovať ")])], 1)]) : _c('div', {
    staticClass: "mortgage-result-broker error-offer"
  }, [_c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": _vm.offer.bank.logo,
      "width": "35",
      "height": "35",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', [_vm._l(_vm.offer.details, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-message blc-color"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  }), !_vm.offer.details || _vm.offer.details.length === 0 ? _c('div', {
    staticClass: "error-message blc-color"
  }, [_vm._v(" Banka pre zadané parametre nevrátila ponuku ani podrobnejší dôvod. ")]) : _vm._e()], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }